// Copyright (c) StrangeBee 2023

import ExternalLink from '@Atoms/ExternalLink/ExternalLink';
import { useLocalMessage } from '@Helpers/locale';
import { AlertImport } from '@Molecules/AlertImport/AlertImport';
import { FileImportDrawer } from '@Molecules/FileImportDrawer/FileImportDrawer';
import React, { ReactElement } from 'react';

import './AnalyzerTemplateImport.scss';

interface AnalyzerTemplateImportProps {
    onSubmit: (formData: FormData) => Promise<void>;
    version: string;
    triggerElem?: ReactElement;
    visible?: boolean;
    onVisibleChange?: (visible: boolean) => void;
}

const AnalyzerTemplateImport = ({
    onSubmit,
    version,
    triggerElem,
    visible,
    onVisibleChange,
}: AnalyzerTemplateImportProps): ReactElement => {
    const i = useLocalMessage();

    return (
        <FileImportDrawer
            onSubmit={onSubmit}
            accept=".zip"
            name="templates"
            className="analyzer-template-import__uploader"
            drawerTitle={i('analyzerTemplates.import.title')}
            visible={visible}
            triggerElem={triggerElem}
            onVisibleChange={onVisibleChange}
            header={
                <AlertImport title={i('analyzerTemplates.import.header.title')}>
                    <>
                        {i('analyzerTemplates.import.header.download')}{' '}
                        <ExternalLink
                            url={`https://download.thehive-project.org/report-templates.zip?version=${version}`}
                        >
                            {i('analyzerTemplates.import.header.link')}
                        </ExternalLink>
                    </>
                </AlertImport>
            }
            uploadTitle={i('analyzerTemplates.import.upload.title')}
            footerLabel={i('analyzerTemplates.import.footer')}
        />
    );
};

export default AnalyzerTemplateImport;
